<template>
  <div class="toast__content">
    <component :is="component" :data="item.data" />
  </div>
</template>

<script>
import { loadShallowAsyncComponent } from '@/helpers/asyncLoaders'

export default {
  name: 'toast-base',

  props: {
    item: {
      type: Object,
      required: true,
      default: null
    }
  },

  data: () => ({
    component: null
  }),

  methods: {
    loadContent () {
      this.component = this.item.component ? loadShallowAsyncComponent(this.item.component) : null
    }
  },

  watch: {
    item: {
      immediate: true,
      handler (value) {
        this.loadContent()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
